import { StatusType, ValidationSubmissionStatus } from '../../../types'

export const mapOverallStatus = (
  status: ValidationSubmissionStatus
): StatusType.Pending | StatusType.Approved | StatusType.Rejected => {
  if (status === StatusType.Failed) {
    return StatusType.Rejected
  }

  if (status === StatusType.Succeeded) {
    return StatusType.Approved
  }

  return StatusType.Pending
}
